import axiosInstance from "../services/secureApi";

export const getRoleListApi = async () => {
  try {
    const response = await axiosInstance.get("/admin/role/list");

    return response.data;
  } catch (error) {
    console.error("Get role list error:", error);
    throw error;
  }
};

export const createRoleApi = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "/admin/createRole",
      payload
    );

    return response.data;
  } catch (error) {
    console.error("Create role error:", error);
    throw error;
  }
};

export const editRoleApi = async (roleId, payload) => {
  try {
    const response = await axiosInstance.put(
      `/admin/editRole/${roleId}`,
      payload
    );

    return response.data;
  } catch (error) {
    console.error("Edit role error:", error);
    throw error;
  }
};
export const viewRoleApi = async (roleId) => {
  try {
    const response = await axiosInstance.get(
      `/admin/viewRole/${roleId}`
    );

    return response.data;
  } catch (error) {
    console.error("View role error:", error);
    throw error;
  }
};